import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Foto1 from './pic/Bild1.jpg';
import Foto2 from './pic/Bild2.jpg';
import WA1 from './pic/WhatsApp Image 2026-06-10 at 10.49.19.jpeg';
import WA2 from './pic/WhatsApp Image 2026-06-10 at 10.59.54.jpeg';
import WA3 from './pic/WhatsApp Image 2026-06-10 at 11.04.09.jpeg';
import WA4 from './pic/WhatsApp Image 2026-06-10 at 11.06.06.jpeg';
import WA5 from './pic/WhatsApp Image 2026-06-10 at 11.10.59.jpeg';

const images = [Foto1, Foto2, WA1, WA2, WA3, WA4, WA5];

function Slideshow() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
  };

  return (
    <div className="max-w-lg mx-auto p-4">
      <Slider {...settings}>
        {images.map((src, i) => (
          <div key={i} className="flex items-center justify-center h-[500px]">
            <div className="relative w-full h-full flex items-center justify-center">
              <img src={src} alt={`Einblick ${i + 1}`} className="max-h-full" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Slideshow;
